import React from "react";
import "./UnsavedModal.css";

const UnsavedModal = ({ show, onStay, onLeave, onSaveAndLeave }) => {
  if (!show) return null;

  return (
    <div className="unsaved-overlay">
      <div className="unsaved-box">
        <h3>⚠️ Bạn có thay đổi chưa lưu!</h3>
        <p>Bạn có muốn lưu trước khi rời trang không?</p>
        <div className="unsaved-actions">
          <button className="unsaved-btn-cancel" onClick={onStay}>Ở lại</button>
          <button className="unsaved-btn-leave" onClick={onLeave}>Rời trang</button>
          {onSaveAndLeave && (
            <button className="unsaved-btn-save" onClick={onSaveAndLeave}>💾 Lưu & Đi</button>
          )}
        </div>
      </div>
    </div>
  );
};

export default UnsavedModal;